<template>
  <div>
    <!-- 微信提示层，默认隐藏 -->
    <div v-if="showWeixinTip" class="weixin-tip">
      <p>请使用右上角的系统浏览器打开</p>
    </div>
    <HomeHeader />

    <!-- Introduction Section -->
    <section class="intro-section">
      <div class="image-wrapper">
        <div class="text-container">
          <h1 class="header-title" v-html="$t('realFeelAI')"></h1>
          <p class="intro-description">{{ $t('description') }}</p>
          <img src="@/assets/images/Frame_6263.png" alt="Item 1" class="log-show" />
          <div class="button-container">
            <a :href="apkUrl" download class="link">
              <button class="custom-button">
                <img src="@/assets/images/android_download.png" alt="Item 1" class="download-icon" />
                <span class="download-title">Android</span>
              </button>
            </a>
            <button class="custom-button" @click="handleButtonClick('ios')">
              <img src="@/assets/images/download-ios.png" alt="Item 1" class="download-icon" />
              <span class="download-title">iOS</span>
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Features Section -->
    <section class="features-section">
      <h2 class="features-title">{{ $t('feature') }}</h2>
      <div class="content-wrapper">
        <div class="wrapper">
          <div class="media-content">
            <div class="media-image small"></div>
            <div class="media-text">&lt; RealFeel AI &gt;</div>
            <div class="media-image large"></div>
          </div>
        </div>

        <div class="feature-details">
          <ul class="features-list">
            <li class="feature-item">
              <img src="@/assets/images/watch_icon.png" alt="Item 1" class="feature-icon" />
              <div class="feature-text">
                <h3 class="feature-title">{{ $t('watchVideo') }}</h3>
                <p class="feature-subtitle">{{ $t('videoType') }}</p>
              </div>
            </li>
            <li class="feature-item">
              <img src="@/assets/images/movie_icon.png" alt="Item 2" class="feature-icon" />
              <div class="feature-text">
                <h3 class="feature-title">{{ $t('aiRecognition') }}</h3>
                <p class="feature-subtitle">{{ $t('aiRecognitionDescription') }}</p>
              </div>
            </li>
            <li class="feature-item">
              <img src="@/assets/images/motions_icon.png" alt="Item 3" class="feature-icon" />
              <div class="feature-text">
                <h3 class="feature-title">{{ $t('motionTracking') }}</h3>
                <p class="feature-subtitle">{{ $t('motionTrackingDescription') }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="benefits-section">
      <h1 class="benefits-title">{{ $t('coreBenefits') }}</h1>
      <div class="benefits-top">
        <div class="benefit-item" :style="{ backgroundImage: `url(${require('@/assets/images/Core_Benefits_2.png')})` }">
          <p class="benefit-text">{{ $t('exclusiveAlgorithm') }}</p>
        </div>
        <div class="benefit-item" :style="{ backgroundImage: `url(${require('@/assets/images/Core_Benefits_1.png')})` }">
          <p class="benefit-text">{{ $t('patentedTechnology') }}</p>
        </div>
        <div class="benefit-item" :style="{ backgroundImage: `url(${require('@/assets/images/Core_Benefits_4.png')})` }">
          <p class="benefit-text">{{ $t('animeVideoSupport') }}</p>
        </div>
        <div class="benefit-item" :style="{ backgroundImage: `url(${require('@/assets/images/Core_Benefits_3.png')})` }">
          <p class="benefit-text">{{ $t('appServices') }}</p>
        </div>
        <div class="benefit-item" :style="{ backgroundImage: `url(${require('@/assets/images/Core_Benefits_5.png')})` }">
          <p class="benefit-text">{{ $t('supportsMoreToys') }}</p>
        </div>
      </div>
    </section>

    <section class="contacts-section">
      <div class="contacts-image-wrapper">
        <div class="detailed-info">
          <p class="centered-text">{{ $t('contactUs') }}</p>
          <div class="right-column">
            <div class="detailed-features">
              <div class="detailed-feature-item">
                <img src="@/assets/images/shopping-building--real-home-tower-building-house-estate.png" alt="Feature 1" class="detailed-feature-icon" />
                <p class="detailed-feature-text">
                  Beijing Aikesi Technology Co., Ltd<br>北京爱可私科技有限公司
                </p>
              </div>
              <div class="detailed-feature-item">
                <img src="@/assets/images/mail-send-envelope--envelope-email-message-unopened-sealed-close.png" alt="Feature 2" class="detailed-feature-icon" />
                <p class="detailed-feature-text">contact@xinteract.cn</p>
              </div>
              <div class="detailed-feature-item">
                <img src="@/assets/images/travel-map-location-pin--navigation-map-maps-pin-gps-location.png" alt="Feature 2" class="detailed-feature-icon" />
                <p class="detailed-feature-text">Block B, Rui Chuang International Center, Chaoyang District, Beijing.<br>
                  北京市朝阳区锐创国际中心B座</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HomeHeader from '@/components/HomeHeader.vue';
import { isWeixinBrowser } from '@/utils/deviceDetector';

export default {
  components: {
    HomeHeader,
  },
  name: 'HomePage',
  data() {
    return {
      apkUrl: '/apk/aikes_v4.0.2.apk', // APK 文件的 URL
      showWeixinTip: false // 新增变量，用于控制微信提示层的显示与隐藏
    };
  },
  methods: {
    handleButtonClick(type) {
      if (type === 'ios') {
        if (isWeixinBrowser()) {
          this.showWeixinTip = true; // 如果是微信浏览器，显示提示层
        } else {
          // 跳转到指定的 App Store 链接
          window.location.href = 'https://apps.apple.com/us/app/aikes/id6714469960';
        }
      }
    }
  }
};
</script>

<style scoped>
/* 如果需要scoped特性 */
@import '@/assets/styles/homepage.css';
.weixin-tip {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    color: white;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end; /* 水平靠右 */
    align-items: flex-start; /* 垂直靠上 */
    z-index: 9999;
  }

  .weixin-tip p {
      margin-bottom: 20px;
      font-size: 16px;
      line-height: 1.5;
      font-weight: bold; /* 字体加粗 */
  }
</style>